import React from "react";
import { connect } from "react-redux";
import LoginPageAlert from "../Login/LoginPageAlert";
import { extractApiErrorMessage } from "../../../utilities/apiErrorMessage";
import { selectAlertMessage, hideModal } from "../../../state/ducks/alert/index";

export function EminPayServiceAlert({ alert, hideModal, inline = false }) {
  if (!alert?.isOpen || alert?.type === "success" || alert?.type === "ALERT_SUCCESS") {
    return null;
  }

  const message = extractApiErrorMessage(alert.message);
  const wrapperClass = inline
    ? "t-eminPayOrder-serviceAlert t-eminPayOrder-serviceAlert--inline"
    : "t-eminPayOrder-serviceAlert";

  return (
    <div className={wrapperClass}>
      <LoginPageAlert messages={message} type="error" onDismiss={hideModal} />
    </div>
  );
}

const mapStateToProps = (state) => ({
  alert: selectAlertMessage(state),
});

const mapDispatchToProps = (dispatch) => ({
  hideModal: () => dispatch(hideModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(EminPayServiceAlert);
